<mat-form-field>
  <mat-label>Search</mat-label>
  <input matInput [ngModel]="search$ | async" #input (ngModelChange)="setSearch(input.value)">
</mat-form-field>
